import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Nftnumbers() {
  return (
    <section className="nft_numbers p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Impact We Delivered with Our Machine Learning Development Services
            </h2>
            {/* <p>
              Enhance the efficiency and security of your digital assets with
              our value-driven NFT development services. We ensure seamless
              integration and exceptional performance of NFTs across all
              platforms.
            </p> */}
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="nft_numbers_main">
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>70%</h2>
                  <p>
                    Increase in prediction
                    <br /> accuracy
                  </p>
                </div>
              </div>
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>30%</h2>
                  <p>
                    Reduction in operational
                    <br /> costs
                  </p>
                </div>
              </div>
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>50%</h2>
                  <p>Faster deployment of machine learning models</p>
                </div>
              </div>
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>65%</h2>
                  <p>Improvement in data processing speed</p>
                </div>
              </div>
              <div className="nft_num_item">
                <div className="nft_item_content">
                  <h2>35%</h2>
                  <p>Reduction in manual workload through automation</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftnumbers;
